/**
 * JALRAKSHAK Modal Dialog Controller
 */

import { SYSTEM_MODULES } from '../data/systemSpecs.js';

export function initModals() {
  const modalBackdrop = document.getElementById('details-modal');
  const modalTitle = document.getElementById('modal-title');
  const modalContent = document.getElementById('modal-body-content');
  const closeBtn = document.querySelector('.modal-close-btn');

  // Open modal on project card or hotspot click
  document.querySelectorAll('[data-open-modal]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const moduleId = trigger.dataset.openModal;
      const moduleData = SYSTEM_MODULES.find(m => m.id === moduleId);

      if (moduleData && modalTitle && modalContent) {
        modalTitle.textContent = moduleData.title;
        
        let specsHtml = moduleData.specs.map(s => `
          <div style="display: flex; justify-content: space-between; padding: 0.6rem 0; border-bottom: 1px solid rgba(255, 255, 255, 0.08); font-size: 0.92rem;">
            <span style="color: var(--text-muted); font-weight: 500;">${s.name}</span>
            <span style="color: #FFFFFF; font-weight: 600;">${s.value}</span>
          </div>
        `).join('');

        modalContent.innerHTML = `
          <div style="margin-bottom: 1.5rem;">
            <span class="badge badge-cyan" style="margin-bottom: 0.8rem;">${moduleData.badge}</span>
            <p style="color: var(--text-secondary); margin-top: 0.5rem; line-height: 1.6;">${moduleData.summary}</p>
          </div>
          <div style="background: rgba(6, 15, 33, 0.7); padding: 1.5rem; border-radius: var(--radius-md); border: 1px solid var(--cyan-border); margin-bottom: 1.5rem;">
            <h4 style="font-size: 1rem; color: var(--cyan-primary); margin-bottom: 1rem; text-transform: uppercase; letter-spacing: 0.05em;">Technical Specifications</h4>
            <div>${specsHtml}</div>
          </div>
          <div>
            <h4 style="font-size: 1rem; color: #FFFFFF; margin-bottom: 0.5rem;">Subsystem Architecture & Operation</h4>
            <p style="color: var(--text-muted); font-size: 0.92rem; line-height: 1.6;">${moduleData.details}</p>
          </div>
        `;

        modalBackdrop?.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // Close handlers
  closeBtn?.addEventListener('click', closeModal);
  
  modalBackdrop?.addEventListener('click', (e) => {
    if (e.target === modalBackdrop) {
      closeModal();
    }
  });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalBackdrop?.classList.contains('active')) {
      closeModal();
    }
  });

  function closeModal() {
    modalBackdrop?.classList.remove('active');
    document.body.style.overflow = '';
  }
}
